export default __webpack_public_path__ + "static/media/Profile.fb742ae1.png";